import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { WorkflowStepDefinition } from 'src/app/models/server/workflow-step-definition';

/**
 * Représente un élément du menu contextuel d'une étape de workflow.
 */
export class WorkflowContextMenuItem {
    /**
     * Constructeur.
     * @param menuItemText : Texte de l'élément du menu.
     * @param menuItemId : Identifiant de l'élément du menu.
     * @param menuItemData : Données attachées à l'élément du menu.
     * @param menuItemIcon : Icône de l'élément du menu.
     * @param enabled : Valeur indiquant si l'élement du menu est actif.
     */
    constructor(
        public menuItemText: string,
        public menuItemId: string,
        public menuItemData: WorkflowStepDefinition,
        public menuItemIcon: IconDefinition,
        public enabled: boolean
    ) {}
}
